import React from 'react';


const Modal = (props) => {
    return (
        <div className="pos-a hig-full w-full opacity-50 z-3"></div>
    )
}

export default Modal;